import { Button, ButtonProps, makeStyles, tokens } from "@fluentui/react-components";
import { Send16Regular } from "@fluentui/react-icons";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $createParagraphNode, $getRoot } from "lexical";
import React from "react";

const SendButtonPlugin: React.FC<ButtonProps & { onClick: () => void; }> = (props) => {
  const [editor] = useLexicalComposerContext();
  const classes = useStyles();

  const handleSend = () => {
    props.onClick(); // 既存の送信処理

    editor.update(() => {
      const root = $getRoot();
      root.clear(); // ルート以下のすべての子ノードを削除
      root.append($createParagraphNode()); // 空の段落ノードを追加（カーソル確保用）
    });
  };
  return (
    <div className={classes.buttonContainer}>
      <Button
        icon={<Send16Regular />}
        appearance="transparent"
        onClick={handleSend}
        disabled={props.disabled}
      />
    </div>
  );
};

const useStyles = makeStyles({
  buttonContainer: {
    position: "absolute",
    right: tokens.spacingHorizontalM,
    bottom: "2px",
    zIndex: 1,
    borderLeft: `1px solid ${tokens.colorNeutralStroke2}`,
  },
});

export default SendButtonPlugin;
